
import React from 'react'
import { LayoutMeetings } from './Layout/LayoutMeetings'


export const MeetingsScreen = () => {
    return (
        <>
            <LayoutMeetings />
        </>
    )
}